import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Input,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Image,
  TableContainer,
  FormControl,
  FormLabel,
  Box,
  Button,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaEdit, FaRupeeSign, FaTrash } from "react-icons/fa";
import toast from "react-hot-toast";
import FoodUpdateModal from "../food/foodUpdateModal";
import RoomBillEdittModal from "./roomBillEditModal";
import Cookie from "js-cookie";
import RoomBillPrintModal from "./roomBillPrintModal";

const RoomBillData = () => {
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();
  const token = Cookie.get("token");
  const handlePrintModalOpen = () => {
    onPrintOpen();
  };

  const [data, setData] = useState([]);
  const [printData, setPrintData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isOpen1, setIsOpen] = useState(false);
  const [roomBill, setRoomBill] = useState({});
  const [id, setId] = useState("");
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const customerId = localStorage.getItem("customerId");

  const fetchData = async () => {
    const response = await axios.get(
      `https://api.hotel.launchlysoftware.in/api/getRoomBilldata/${customerId}`,
    );
    setData(response.data);
    setFilteredData(response.data);
  };

  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchData3();
  }, [customerId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    }
    filterData(
      searchTerm,
      name === "startDate" ? value : startDate,
      name === "endDate" ? value : endDate,
    );
  };
  const handleDelete = async () => {
    try {
      await axios.delete(
        `https://api.hotel.launchlysoftware.in/api/deleteRoomBill/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success(" deleted successfully.");
      setIsOpen(false);

      fetchData();
    } catch (error) {
      console.error("Error deleting room:", error);
      toast.error(error.response.data.message);
    }
  };

  const updateRoomBill = async (id) => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRommBillDataById/${customerId}/${id}`,
      );
      setRoomBill(response.data.roomBill);
      setId(id);
      onEditOpen();
    } catch (error) {
      console.error("Error fetching room data for update:", error);
      toast.error("Failed to fetch room data.");
    }
  };
  const DeleteModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  const filterData = (term, startDate, endDate) => {
    let filtered = data;

    // Filter by search term (phone number or registration)
    if (term) {
      filtered = filtered.filter(
        (item) =>
          item.phoneNo.includes(term) ||
          item.registration.includes(term) ||
          item.name.toLowerCase().includes(term.toLowerCase()),
      );
    }

    // Filter by date range
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= start && itemDate <= end;
      });
    }

    setFilteredData(filtered);
  };

  const formatTimeToAMPM = (time) => {
    const formattedTime = new Date(`6000-01-01T${time}`);
    return formattedTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };
  const exportToExcel = () => {
    // Filter out _id and createdAt fields from the data
    const cleanedData = filteredData.map(({ _id, createdAt, ...rest }) => rest);

    // Create a worksheet from the cleaned data
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);

    // Capitalize the first letter of each header
    const headers = Object.keys(cleanedData[0] || {});
    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      worksheet[cellAddress].v =
        header.charAt(0).toUpperCase() + header.slice(1);
    });

    // Calculate totals for cash and online columns
    let totalCash = 0;
    let totalOnline = 0;

    cleanedData.forEach((row) => {
      totalCash += parseInt(row.cash) || 0;
      totalOnline += parseInt(row.online) || 0;
    });

    // Add the totals row
    const totalRow = {
      cash: totalCash,
      online: totalOnline,
      // Add any other columns you want to include in the totals row
    };

    // Append the total row to the worksheet
    XLSX.utils.sheet_add_json(worksheet, [totalRow], {
      skipHeader: true,
      origin: -1,
    });

    // Add borders to all cells in the worksheet
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);

        if (!worksheet[cellRef]) continue;
        if (!worksheet[cellRef].s) worksheet[cellRef].s = {};

        worksheet[cellRef].s.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      }
    }

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Cash Data");

    // Write the workbook to an Excel file
    XLSX.writeFile(workbook, "RoomBillData.xlsx");
  };
  const handlePrint = (item) => {
    const content = `
        <html>
          <head>
            <style>
              body { font-family: Arial, sans-serif; color: purple; }
              .grid-container { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 10px; }
              .grid-item { padding: 8px; border: 1px solid #ddd; }
              .container { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #dddddd; text-align: left; padding: 8px; }
              th { background-color: #f2f2f2; }
              .container2 { display: flex; flex-direction: row; padding: 8px; }
              .column { display: flex; flex-direction: column; border: 1px solid black; }
              .column-right { display: flex; flex-direction: column; border-top: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; border-left: 0; }
              .header { border-bottom: 1px solid black; background-color: #e2e8f0; padding: 4px; }
              .text { padding: 2px; }
              .border-top { border-top: 1px solid black; }
            </style>
          </head>
          <body>
            <h2 style="text-align: center">Room Invoice</h2>
            <div style="display: flex; justify-content: center; align-items: center; gap: 18px; color: purple">
              ${printData
                .map(
                  (item) => `
                <img src="${item.imageUrl}" style="width: 150px; height: 150px; border-radius: 12px; margin-right: 10px; background: #FAFAFA" />
                <div>
                  <h2>${item.name}</h2>
                  <p>${item.adress}</p>
                  <p>Phone: ${item.phoneNo}</p>
                  <p>Website: ${item.website}</p>
                  <p>Email: ${item.email}</p>
                  <p>GST No: ${item.gstNo}</p>
                </div>
              `,
                )
                .join("")}
            </div>
            <div class="grid-container">
              <p>Name: ${item.name}</p>
              <p>Registartion: ${item.registration}</p>
              <p>Date: ${item.date}</p>
              <p>Address: ${item.address}</p>
              <p>Phone No: ${item.phoneNo}</p>
              <p>Company Name: ${item.companyName}</p>
              <p>GstNo: ${item.gstNo}</p>
              <p>CheckIn: ${item.checkIn}</p>
              <p>CheckInTime: ${item.checkInTime}</p>
              <p>CheckOut: ${item.checkOut}</p>
              <p>CheckOutTime: ${item.checkOutTime}</p>
              <p>Room No: ${item.roomNo}</p>
              <p>Bill No: ${item.billNo}</p>
              <p>Rate: ${item.rate}</p>
              
              <p>Cgst: ${item.cgst}</p>
              <p>Sgst: ${item.sgst}</p>
              <p>Service Charge: ${item.serviceCharge}</p>
              <p>Total: ${item.total}</p>
              
              
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              ${printData
                .map(
                  (print) => `
                <div>
                  
                  <p>A/C No: ${print.acNo}</p>
                  <p>IFSC CODE: ${print.ifsc}</p>
                  <p>BRANCH: ${print.branch}</p>
                  <p>CONTACT NO: ${printData.phoneNo}</p>
                   <p>Front Office Signature- </p>
                    <p>Date- </p>
                </div>
                <div>
                  <p>Guest  Signature- </p>
                <p>Date - </p>
                </div>
              `,
                )
                .join("")}
            </div>
           
           
            <script>
              window.onload = () => window.print();
            </script>
          </body>
        </html>
      `;
    const printWindow = window.open("", "", "height=600,width=800");
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();
  };

  return (
    <div>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        mt={4}
        mb={4}
      >
        <FormControl>
          <Input
            w="80%"
            type="text"
            placeholder="Search by Phone No or Registration and name"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </FormControl>
        <FormControl
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <FormLabel htmlFor="startDate">Start Date</FormLabel>
          <Input
            id="startDate"
            width="40%"
            name="startDate"
            type="date"
            value={startDate}
            onChange={handleDateChange}
          />
        </FormControl>
        <FormControl
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <FormLabel htmlFor="endDate">End Date</FormLabel>
          <Input
            width="40%"
            id="endDate"
            name="endDate"
            type="date"
            value={endDate}
            onChange={handleDateChange}
          />
        </FormControl>
      </Box>
      <Button colorScheme="blue" onClick={exportToExcel} p={2} mb={5}>
        Export to Excel File
      </Button>
      <Button
        colorScheme="blue"
        onClick={handlePrintModalOpen}
        p={2}
        ml={3}
        mb={5}
      >
        Print
      </Button>
      <TableContainer width="full">
        <Table size="sm" variant="striped" colorScheme="teal">
          <TableCaption>Room Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Bill No</Th>
              <Th>Name</Th>
              <Th>GST No</Th>
              <Th>Rate</Th>
              <Th>Check-In</Th>
              <Th>Check-Out</Th>
              <Th>Address</Th>
              <Th>Date</Th>
              <Th>Phone No</Th>
              <Th>Company Name</Th>
              <Th>Check-In Time</Th>
              <Th>Check-Out Time</Th>
              <Th>Room No</Th>
              <Th>Image</Th>
              <Th>Floor No</Th>
              <Th>Category</Th>
              <Th>Type</Th>
              <Th>Discount</Th>
              <Th>CGST</Th>
              <Th>SGST</Th>
              <Th>Registration</Th>
              <Th>Service Charge</Th>
              <Th>Total</Th>
              <Th>Print</Th>
              <Th>Edit</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((item, index) => (
              <Tr key={index}>
                <Td>{item.billNo}</Td>
                <Td>{item.name}</Td>
                <Td>{item.gstNo}</Td>
                <Td>{item.rate}</Td>
                <Td>{item.checkIn}</Td>
                <Td>{item.checkOut}</Td>
                <Td>{item.address}</Td>
                <Td>{item.date}</Td>
                <Td>{item.phoneNo}</Td>
                <Td>{item.companyName}</Td>
                <Td>{item.checkInTime ? item.checkInTime : null}</Td>
                <Td>{item.checkOutTime ? item.checkOutTime : null}</Td>
                <Td>{item.roomNo}</Td>
                <Td>
                  <Image w="60" src={item.image} />
                </Td>
                <Td>{item.floorNo}</Td>
                <Td>{item.category}</Td>
                <Td>{item.ac}</Td>
                <Td>{item.discount}</Td>
                <Td>{item.cgst}</Td>
                <Td>{item.sgst}</Td>
                <Td>{item.registration}</Td>
                <Td>{item.serviceCharge}</Td>
                <Td>{item.total}</Td>
                <Td>
                  <Button
                    variant="solid"
                    colorScheme="blue"
                    onClick={() => handlePrint(item)}
                  >
                    Print
                  </Button>
                </Td>
                <Td>
                  <Button
                    variant="solid"
                    colorScheme="green"
                    onClick={() => updateRoomBill(item._id)}
                  >
                    <FaEdit />
                  </Button>
                </Td>
                <Td>
                  <Button
                    variant="solid"
                    colorScheme="red"
                    onClick={() => DeleteModal(item._id)}
                  >
                    <FaTrash />
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <RoomBillEdittModal
        customerId={customerId}
        isOpen={isEditOpen}
        onOpen={onEditOpen}
        onClose={onEditClose}
        data={roomBill}
        id={id}
        setSelectId={setId}
      />
      <RoomBillPrintModal
        customerId={customerId}
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        data={printData}
        roomBillData={filteredData}
      />
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </div>
  );
};

export default RoomBillData;
